"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useRef } from "react";
import AboutSectionRight from "~/public/assets/about/about-section-right.png";
import Bg_Section from "~/public/assets/backgrounds/bg-section-bottom.png";
import { NumbersFlowSection } from "../numbers-flow/numbers-flow-section";
import { useAboutCardsAnimation } from "./use-about-cards-animation";
export type AboutSectionProps = {
  tag?: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
};
export default function AboutSection(t0) {
  const $ = _c(20);
  const {
    tag: t1,
    title: t2,
    description
  } = t0;
  const tag = t1 === undefined ? "Sobre a Flow" : t1;
  const title = t2 === undefined ? "Criamos produtos digitais com estrat\xE9gia, design e tecnologia." : t2;
  const sectionRef = useRef(null);
  useAboutCardsAnimation(sectionRef);
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="hidden md:inline-flex w-3 h-3 border border-gray-300 absolute -top-1.75 -left-1.75 bg-gray-1000 z-40" />;
    t4 = <span className="hidden md:inline-flex w-3 h-3 border border-gray-300 absolute -top-1.75 -right-1.75 bg-gray-1000 z-40" />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  let t5;
  if ($[2] !== tag) {
    t5 = <p className="tag">{tag}</p>;
    $[2] = tag;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== title) {
    t6 = <h2 className="title">{title}</h2>;
    $[4] = title;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== description) {
    t7 = description && <p className="description pt-11">{description}</p>;
    $[6] = description;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = <div className="relative z-40 max-w-134 flex xl:items-end justify-between gap-12 xl:gap-8 max-lg:flex-col"><div>{t5}{t6}{t7}</div></div>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Image src={AboutSectionRight} alt={"Fotos de Hero com \xEDcone Flow"} aria-hidden="true" className="pointer-events-none absolute z-20 top-0 right-0 w-full max-w-100 hidden md:block lg:max-w-150" width={2000} height={2000} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="py-32"><NumbersFlowSection /></div>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t8) {
    t11 = <div className="container relative md:border-x md:border-gray-300 px-6 lg:px-18 3xl:px-24! pt-24 md:pt-36">{t3}{t4}{t8}{t9}{t10}</div>;
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Image src={AboutSectionRight} alt={"Fotos de Hero com \xEDcone Flow"} aria-hidden="true" className="pointer-events-none absolute z-20 top-0 right-0 w-full max-w-100 opacity-60 block md:hidden" width={2000} height={2000} />;
    t13 = <Image src={Bg_Section} alt="Background decorativo" className="absolute w-full h-full min-h-150 bottom-0 left-0 pointer-events-none hidden md:block" priority={false} width={2000} height={2000} />;
    $[16] = t12;
    $[17] = t13;
  } else {
    t12 = $[16];
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t11) {
    t14 = <section ref={sectionRef} className="md:container-padding relative bg-gray-1100 border-t border-gray-300" id="sobre">{t11}{t12}{t13}</section>;
    $[18] = t11;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  return t14;
}